import { render, staticRenderFns } from "./OrderCusInput.vue?vue&type=template&id=236cac0e"
import script from "./OrderCusInput.vue?vue&type=script&lang=js"
export * from "./OrderCusInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports